export const BASE_URL = 'https://api.themoviedb.org/3/';
export const API_KEY = '481cbb6dba5121edc01136f73aa6b3c6';



// Щоб отримати доступ дивіться у файлі example.js

